import React, { useState } from 'react';
import { Link as RouterLink } from 'next/link';
import { Box, Link, Typography } from '@material-ui/core';
import { colors, Card, Flex } from '@eureca/eureca-ui';
import { FiMail } from 'react-icons/fi';
import { withApollo } from '@/lib/withApollo';
import Layout from '../layouts/default';
import ResetPasswordForm from '../components/template/reset-password-form';

const styles = {
  card: {
    maxWidth: '476px',
    margin: 'auto',
  },
};

function EmailSentCard() {
  return (
    <Card style={{ ...styles.card }}>
      <Box p={6}>
        <Flex directionRow alignCenter>
          <Box mr={1}>
            <FiMail color={colors.green1} />
          </Box>
          <Typography variant="subtitle1">E-mail enviado!</Typography>
        </Flex>
        <Box mt={4}>
          <Flex directionRow alignCenter>
            <Box
              id="dash"
              mr={1.5}
              width="16px"
              height="1px"
              bgcolor={colors.gray3}
            />
            <Typography variant="h5">Check sua caixa de entrada</Typography>
          </Flex>
          <Typography>
            Enviamos em seu e-mail o link para redefinição da senha.
          </Typography>
        </Box>
        <Box mt={4}>
          <Flex directionRow alignCenter>
            <Box
              id="dash"
              mr={1.5}
              width="16px"
              height="1px"
              bgcolor={colors.gray3}
            />
            <Typography variant="h5">Não recebeu o e-mail?</Typography>
          </Flex>

          <Typography>
            Por favor, confira sua caixa de spam. Se o e-mail não estiver lá,
            tente novamente.
          </Typography>
        </Box>
        <Box mt={4}>
          <Typography>
            <Link component={RouterLink} href="/">
              Voltar para página de login
            </Link>
          </Typography>
        </Box>
      </Box>
    </Card>
  );
}

function ResetPassword() {
  const [showCard, setShowCard] = useState(false);

  return (
    <Layout>
      {!showCard ? (
        <ResetPasswordForm submitSuccess={() => setShowCard(!showCard)} />
      ) : (
        <EmailSentCard />
      )}
    </Layout>
  );
}
export default withApollo({ ssr: true })(ResetPassword);
